module.exports = __webpack_public_path__ + "static/media/traca_poster.0ffe487e.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/projects/traca_poster.jpeg
// module id = 170
// module chunks = 0